import {Injectable} from '@angular/core';
import {DEFAULT_PAGE_SIZE} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class PagingService {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    constructor() {}

    setPageSize(resourceName: string, pageSize: number): void {
        window.localStorage.setItem('pageSize-' + resourceName, String(pageSize));
    }

    getPageSize(resourceName: string): number {
        if (window.localStorage.getItem('pageSize-' + resourceName) != null) {
            return Number.parseInt(window.localStorage.getItem('pageSize-' + resourceName));
        }
        return DEFAULT_PAGE_SIZE;
    }
}
